// Self-hosted fonts. Bundling them (rather than linking Google Fonts) keeps the
// critical path free of a third-party connection, which is what pushed out LCP
// on the invt site.
require("@fontsource-variable/jetbrains-mono");
require("@fontsource-variable/inter");
require("@fontsource/newsreader/400-italic.css");
require("./src/styles/global.css");

// The agent provider is mounted above the router so a page navigation does not
// destroy an open conversation. See src/wrapRootElement.tsx. CommonJS to match
// the rest of this file - Gatsby refuses a plugin file that mixes the two.
exports.wrapRootElement = require("./src/wrapRootElement").wrapRootElement;
